exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".region-setting-form {\n  border: none;\n  text-align: left;\n  border-radius: 0;\n  border-bottom: 1px solid #aaa;\n  float: left; }\n  .region-setting-form:active {\n    outline: none; }\n", ""]);

